import {ISeoMetadata} from 'types';

export const replaceProviderSeoWith = (
  seoData: ISeoMetadata | undefined,
  providerName: string | undefined,
  categoryNames: string,
  slug: string | undefined,
): ISeoMetadata | undefined => {
  if (!seoData || !providerName || !categoryNames || !slug) return;

  const replaceString = (str: string) => str?.replace(/{provider_name}/g, providerName);
  const replaceMenu = (str: string) => str?.replace(/{provider_menu}/g, categoryNames);
  const replaceSlug = (str: string) => str?.replace(/{provider_slug}/g, slug);

  return {
    ...seoData,
    title: replaceString(seoData.title),
    title_ro: replaceString(seoData.title_ro),
    title_ru: replaceString(seoData.title_ru),
    title_en: replaceString(seoData.title_en),
    description: replaceMenu(replaceString(seoData.description)),
    description_ro: replaceMenu(replaceString(seoData.description_ro)),
    description_ru: replaceMenu(replaceString(seoData.description_ru)),
    description_en: replaceMenu(replaceString(seoData.description_en)),
    og_title: replaceString(seoData.og_title),
    og_title_ro: replaceString(seoData.og_title_ro),
    og_title_ru: replaceString(seoData.og_title_ru),
    og_title_en: replaceString(seoData.og_title_en),
    dynamic_h1: replaceString(seoData.dynamic_h1),
    dynamic_h1_ro: replaceString(seoData.dynamic_h1_ro),
    dynamic_h1_ru: replaceString(seoData.dynamic_h1_ru),
    dynamic_h1_en: replaceString(seoData.dynamic_h1_en),
    og_url: replaceSlug(seoData?.og_url ?? ''),
  };
};
